import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full bg-white rounded-xl px-6 pt-6 pb-8 flex flex-col justify-start min-h-40" }


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const lenderTitle = 'Preferred Lender';
const lenderText = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Bibendum in tincidunt amet amet morbi nunc porta nec. Amet, amet ullamcorper nunc aenean fermentum mi. Velit nec nibh et, tristique fermentum est nibh et, amet. Turpis massa fringilla  massa quam nibh condimentum etiam.';
const lenderButton = 'Go to Lender';
const lenderLogo = '/images/hlx_logo.png';

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h2", { class: "t-22m text-wrh-blue-dark" }, _toDisplayString(lenderTitle)),
    _createElementVNode("div", { class: "flex items-end justify-between gap-6 mt-6" }, [
      _createElementVNode("p", { class: "flex flex-1 self-start t-14r" }, _toDisplayString(lenderText)),
      _createElementVNode("img", {
        src: lenderLogo,
        alt: lenderTitle,
        class: "flex-shrink-0"
      }),
      _createElementVNode("button", { class: "px-14 py-1 rounded-md bg-wrh-blue-light text-white" }, _toDisplayString(lenderButton))
    ])
  ]))
}
}

})